import React, {useMemo, useState} from 'react';
import {useGetRouteGraphhopperQuery} from "@containers/graphhopper/hooks/useGraphhopperQuery";
import DefaultPointChangeCorrectionsSingleVoyages
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/DefaultPointChangeCorrectionsSingleVoyages";
import {
    ICorrectionWayPointSingleVoyage,
    IWayPointCreationWithCorrectionsSingleVoyage
} from "@containers/singleVoyage/types/point";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {LatLng} from "leaflet";
import PolylineDraggableCorrectionPointsSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/PolylineDraggableCorrectionPointsSingleVoyage";
import MarkersDraggableCorrectionPointsSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/MarkersDraggableCorrectionPointsSingleVoyage";
import {LatLngCor} from "@ui/leafletCustom/types/latLng";
import {
    createCorrectionWayPointByLatLng
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/helpers/createCorrectionWayPointByLatLng";
import {
    useActionsCorrectionPointsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/hooks/useActionsCorrectionPointsMutateSingleVoyage";
import OnSaveBtnCorrectionPointsModeBtnMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/actionBarChangeCorrectionPoints/OnSaveBtnCorrectionPointsModeBtnMutateSingleVoyage";
import {
    onSaveCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";


interface IProps {
    fromPoint: IWayPointCreationWithCorrectionsSingleVoyage
    toPoint: IWayPointCreationWithCorrectionsSingleVoyage
    onSave: onSaveCorrectionPointsSingleVoyage,
    disabled?: boolean
}


const PositionsDraggableCorrectionPointsSingleVoyage = ({
                                                            fromPoint,
                                                            toPoint,
                                                            onSave,
                                                            disabled,
                                                        }: IProps) => {

    const [targetPoints, setTargetPoints] = useState<ICorrectionWayPointSingleVoyage[]>([
        createCorrectionWayPointByLatLng(getLatLngFromPointGeomCoordinates(fromPoint?.geom)),
        ...(fromPoint.correctionWaypoints || []),
        createCorrectionWayPointByLatLng(getLatLngFromPointGeomCoordinates(toPoint?.geom))
    ])

    const {
        onClickPolyline,
        onRemoveMarker,
        onDragEndMarker,
    } = useActionsCorrectionPointsMutateSingleVoyage({
        setTargetPoints
    })

    const {
        data
    } = useGetRouteGraphhopperQuery({
        params: {
            points: targetPoints
        }
    })

    const currentPositions: LatLngCor[] = useMemo(() => {
        if (!data?.paths?.length) {
            return []
        }
        return data.paths[0]?.points?.coordinates?.map(([lat, lng]) => {
            return new LatLng(lat, lng)
        })

    }, [data])

    const handleSave = async () => {
        await onSave({
            points: targetPoints.slice(1, -1),
            fromPoint,
        })
    }

    return (
        <>
            <DefaultPointChangeCorrectionsSingleVoyages
                point={fromPoint}
            />
            <DefaultPointChangeCorrectionsSingleVoyages
                point={toPoint}
            />

            <PolylineDraggableCorrectionPointsSingleVoyage
                positions={currentPositions}
                onClickPolyline={onClickPolyline}
            />

            <MarkersDraggableCorrectionPointsSingleVoyage
                points={targetPoints}
                onRemoveMarker={onRemoveMarker}
                onDragEndMarker={onDragEndMarker}
            />

            <OnSaveBtnCorrectionPointsModeBtnMutateSingleVoyage
                onClick={handleSave}
                disabled={disabled}
            />
        </>
    )

};

export default PositionsDraggableCorrectionPointsSingleVoyage;